import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormMixin from '@/amui-fe/mixins/formMixin';
let AmFeInputField = class AmFeInputField extends Mixins(FormMixin) {
  get label_i18n() {
    return this.label === '输入框' ? window.lowcode.i18n.get('apaas_amui_inputfield_label', '输入框') : this.label;
  }
};
AmFeInputField.componentName = 'AmFeInputField';
__decorate([Prop({
  default: false
})], AmFeInputField.prototype, "remoteSearch", void 0);
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_formfieldinput_placeholder', '请输入');
  }
})], AmFeInputField.prototype, "placeholder", void 0);
__decorate([Prop({
  default: 'text'
})], AmFeInputField.prototype, "type", void 0);
__decorate([Prop({
  default: 0
})], AmFeInputField.prototype, "minlength", void 0);
__decorate([Prop({
  default: 99
})], AmFeInputField.prototype, "maxlength", void 0);
__decorate([Prop({
  default: false
})], AmFeInputField.prototype, "showWordLimit", void 0);
__decorate([Prop({
  default: false
})], AmFeInputField.prototype, "clearable", void 0);
__decorate([Prop({
  default: 2
})], AmFeInputField.prototype, "rows", void 0);
__decorate([Prop({
  default: 'value'
})], AmFeInputField.prototype, "valueKey", void 0);
__decorate([Prop({
  default: 300
})], AmFeInputField.prototype, "debounce", void 0);
__decorate([Prop({
  default: 'bottom-start'
})], AmFeInputField.prototype, "placement", void 0);
__decorate([Prop(Function)], AmFeInputField.prototype, "fetchSuggestions", void 0);
__decorate([Prop()], AmFeInputField.prototype, "popperClass", void 0);
__decorate([Prop({
  default: true
})], AmFeInputField.prototype, "triggerOnFocus", void 0);
__decorate([Prop()], AmFeInputField.prototype, "name", void 0);
__decorate([Prop({
  default: false
})], AmFeInputField.prototype, "selectWhenUnmatched", void 0);
__decorate([Prop()], AmFeInputField.prototype, "prefixIcon", void 0);
__decorate([Prop()], AmFeInputField.prototype, "suffixIcon", void 0);
__decorate([Prop({
  default: false
})], AmFeInputField.prototype, "hideLoading", void 0);
__decorate([Prop({
  default: true
})], AmFeInputField.prototype, "popperAppendToBody", void 0);
__decorate([Prop({
  default: false
})], AmFeInputField.prototype, "highlightFirstItem", void 0);
AmFeInputField = __decorate([Component({
  name: 'AmFeInputField'
})], AmFeInputField);
export default AmFeInputField;